// extracted by mini-css-extract-plugin
export default {"web5-device-connection-successful-form":"mhGJmp","web5DeviceConnectionSuccessfulForm":"mhGJmp"};